(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cards"]) return;
  try {
    

(function($) {

    $( document ).ready(function() {

        if ( $(window).width() < 1024 ){

                $('.banner-cards').owlCarousel({
                    center: true,
                    items:1,
                    loop:true,
                    margin: 40,
                    dots: false,
                    stagePadding: 80,
                });

            } else {
                $('.banner-cards').removeClass("owl-carousel");
                $('.banner-cards').removeClass("owl-theme");

            }   

            $(document).on('click','.cards--close, .cards__button', function(event){
                event.stopPropagation();
                $(".cards").removeClass("cards--close");
                $(".cards__text, .cards__title").animate({opacity:0});
                return false;  
            });  

            $(".cards__button").click(function(event){
                if(!$(".cards").hasClass("cards--close")){
                    event.stopPropagation();
                    $(".cards").addClass("cards--close");
                    $(".cards__text, .cards__title").animate({opacity:1});
                    return false;
                }
            }) 
    }); 

})(jQuery);


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["homepage-content"]) return;
  try {
    
    (function($) {

        $('.top-brands__switch-item').on('click', function(){
            $('.top-brands__switch-item').removeClass('active');
            $(this).addClass('active');

            $('.top-brands__list').removeClass('active');
            $('.top-brands__list--'+$(this).data('type')).addClass('active');
        });

    })(jQuery);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["newsletter-modal"]) return;
  try {
    
// modal actions
var isNewsletterShowed = Cookies.get('showed-newsletter-modal')

$('.modal').on('modal-close', function(e, el) {
  if (el.modal.hasClass('modal--newsletter')) {
    Cookies.set('showed-newsletter-modal', 1, { expires: 30 });
  }
});

if (!isNewsletterShowed) {
  Suit.modal.open('.modal--newsletter');

  // form actions
  var formAction = $('.modal--newsletter form').attr('action');
  var hash = formAction.indexOf('#');
  if (hash >= 0) {
    $('.modal--newsletter form').attr('action', formAction.replace(formAction.substring(hash,99999),''));
  }

  $('.modal--newsletter #mc-embedded-subscribe-form-2').submit(function(e) {
    //e.preventDefault();

    var check = true;

    $('.modal--newsletter #mc-embedded-subscribe-form-2').find('.mce_inline_error').remove();

    if ($('.modal--newsletter #mc-embedded-subscribe-form-2').find('.newsletter__email').val().length === 0) {
        $('.modal--newsletter #mc-embedded-subscribe-form-2').find('.email').append('<div class="mce_inline_error for-email">' + Shopify.trans.newsletterFieldRequired + '</div>');
        check = false;
    }

    if (!$('.modal--newsletter #mc-embedded-subscribe-form-2').find('.gender input:checked').length > 0) {
        $('.modal--newsletter #mc-embedded-subscribe-form-2').find('.gender').append('<div class="mce_inline_error for-gender">' + Shopify.trans.newsletterFieldRequired + '</div>');
        check = false;
    }
    else{
        $('.mce_inline_error.for-gender').remove();
    }

    if($(this).parent().find('.privacy:checked').length > 0 && check){
      $.ajax({
          url: $('#mc-embedded-subscribe-form-2').attr('action'),
          type: 'get',
          data: $('#mc-embedded-subscribe-form-2').serialize(),
          dataType: 'jsonp',
          jsonp: 'c',
          cache: false,
          contentType: 'application/json; charset=utf-8',
          error: function (err) { $('.modal--newsletter #mce-responses').html(err.msg); },
          success: function (data) {
            console.log("SEND");
            ga('send', 'event', 'newsletter', 'click', 'newsletterPopup', '1');
            $('.modal--newsletter #mce-responses').html(data.msg);
            console.log("DONE");
          }
      });
    }
    else{
        $(this).parent().find('.privacy+label').addClass('error');
        return false;
    }
  })
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["text-loop"] && !window.DesignMode) return;
  try {
    

(function($) {

    $( document ).ready(function() {

      var $textLoopWrapper = $(".loop");
      var $textLoop = $(".loop__text");
      var listWidth = $textLoop.outerWidth(true);
      var textValue = '<span class="loop__sentence">' + $textLoop.text() + '</span>';
    
      while(listWidth < $(window).width()){
        $textLoop.append(textValue);
        listWidth = $textLoop.outerWidth(true);
      }
    
      var $clonedTextLoop = $textLoop.clone();
    
      var endPos = listWidth;
    
      $textLoop.add($clonedTextLoop).css({
        "width" : listWidth + "px"
      });
    
      $clonedTextLoop.addClass("cloned").appendTo($textLoopWrapper);
    
      //TimelineMax
      var infinite = new TimelineMax({repeat: -1, paused: true});

      if ( $(window).width() > 1024 ){
        var time = 30;
      }
      else{
          var time = 10;
      }
    
      infinite
        .fromTo($textLoop, time, {rotation:0.01,x:0}, {force3D:true, x: -listWidth, ease: Linear.easeNone}, 0)
        .fromTo($clonedTextLoop, time, {rotation:0.01, x:listWidth}, {force3D:true, x:0, ease: Linear.easeNone}, 0)
        .set($textLoop, {force3D:true, rotation:0.01, x: listWidth})
        .to($clonedTextLoop, time, {force3D:true, rotation:0.01, x: -listWidth, ease: Linear.easeNone}, time)
        .to($textLoop, time, {force3D:true, rotation:0.01, x: 0, ease: Linear.easeNone}, time)
        .progress(1).progress(0)
        .play();
    
      //Pause/Play      
      $textLoopWrapper.on("mouseenter", function(){
        infinite.pause();
      }).on("mouseleave", function(){
        infinite.play();
      });

     }); // close document ready

})(jQuery);
   


  } catch(e) { console.error(e); }
})();
})();
